import Vue from 'vue'
import Vuetify from 'vuetify'
import colors from 'vuetify/lib/util/colors'
import '@fortawesome/fontawesome-pro/css/all.css'

import pt from 'vuetify/lib/locale/pt'
import en from 'vuetify/lib/locale/pt'

const locales = {
  en,
  pt,
}

const current = navigator.language.split('-')[0]

Vue.use(Vuetify)

export default new Vuetify({
  locales,
  current,
  icons: {
    iconfont: 'fa'
  },
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: colors.orange.darken2,
      }
    }
  }
})
